import PropTypes from 'prop-types'
import React from 'react'

import Button from 'components/Button'
import { auth } from 'data'

export default function ButtonSignOut(props) {
  return (
    <Button {...props} onClick={auth.signOut} />
  )
}

ButtonSignOut.propTypes = {
  children: PropTypes.node,
}

ButtonSignOut.defaultProps = {
  children: 'Sign out',
}



// WEBPACK FOOTER //
// ./src/components/ButtonSignOut/ButtonSignOut.js